// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2Gqdx","imageUploader":"EGiftCard_imageUploader__3TYty"};